<template>
  <div
    v-if="overlay"
    class="tw:fixed tw:inset-0 tw:z-50 tw:flex tw:items-center tw:justify-center tw:bg-black/40"
  >
    <div :class="sizeClass">
      <svg
        :fill="color"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        class="tw:w-full tw:h-full"
      >
        <path
          d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
          opacity=".25"
        />
        <path
          d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            dur="0.75s"
            values="0 12 12;360 12 12"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </div>
  </div>
  <div v-else :class="sizeClass">
    <svg
      :fill="color"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      class="tw:w-full tw:h-full"
    >
      <path
        d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
        opacity=".25"
      />
      <path
        d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          dur="0.75s"
          values="0 12 12;360 12 12"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  size?: 'sm' | 'md' | 'lg'
  color?: string
  overlay?: boolean
}>(), {
  size: 'md',
  color: 'var(--maincolor)',
  overlay: false,
})

const SIZE_MAP: Record<string, string> = {
  sm: 'tw:w-5 tw:h-5',
  md: 'tw:w-12 tw:h-12',
  lg: 'tw:w-20 tw:h-20',
}

const sizeClass = computed(() => SIZE_MAP[props.size] ?? SIZE_MAP.md)
</script>
